import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { ConfirmInfo as ConfirmInfoForm } from "ui/auth/ConfirmInfo"

export const ConfirmInfo = (props) => (
  <AuthenticationLayout type="signup">
    <ConfirmInfoForm {...props} />
  </AuthenticationLayout>
)
